import React from 'react';
import { motion } from 'framer-motion';
import { Container } from 'react-bootstrap';
import PageTransition from '../components/PageTransition';

const Impressum: React.FC = () => {
  return (
    <PageTransition>
      <div className="py-5">
        <Container>
          <motion.div
            initial={{ y: 10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }}
            className="page-header"
          >
            <h1 style={{ color: '#FC5000' }}>Impressum</h1>
          </motion.div>

          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.2 }}
            className="card border-0 shadow-sm"
          >
            <div className="card-body p-4">
              <h2 className="h4 mb-4">Betreiber der Website</h2>
              <p>
                <strong>CT Auto-Werkstätte</strong><br />
                Wallenmahd 23/C3<br />
                6850 Dornbirn<br />
                Mobiltelefon: +43 664 2508088<br />
                Mail: <a href="mailto:kontakt@cartech-dornbirn.at" className="text-decoration-none">kontakt@cartech-dornbirn.at</a>
              </p>

              <h2 className="h4 mb-4 mt-5">Unternehmensdaten</h2>
              <p>
                <strong>Rechtsform:</strong> OG<br />
                <strong>Geschäftsführer:</strong> André Haller<br />
                <strong>Inhaber:</strong> André Haller, Selman Kahraman<br />
                <strong>Unternehmensgründung:</strong> 18.11.2016<br />
                <strong>Gewerbe:</strong> Karosseriebau und Karosserielackierer verbunden mit Kraftfahrzeugtechnik (verbundenes Handwerk)<br />
                <strong>UID-Nummer:</strong> ATU71691001<br />
                <strong>Firmenbuchnummer:</strong> FN 461946h
              </p>

              <h2 className="h4 mb-4 mt-5">Allgemeine Nutzungsbedingungen</h2>
              
              <h3 className="h5 mb-3">1. Haftungsausschluss</h3>
              <p>
                Obwohl die Seiten mit größter Sorgfalt erstellt wurden, kann keine Gewähr für die Richtigkeit, Vollständigkeit und Aktualität der bereitgestellten Informationen übernommen werden. Der Betreiber der Website bemüht sich darum, Fehler oder Irrtümer zu berichtigen, wenn er Kenntnis davon erhält – danke für diesbezügliche Hinweise. Es wird auch keine Gewähr für die Verfügbarkeit oder den Betrieb der gegenständlichen Website und ihrer Inhalte übernommen. Jede Haftung für unmittelbare, mittelbare oder sonstige Schäden, unabhängig von deren Ursachen, die aus der Benutzung oder Nichtverfügbarkeit der Website sowie der bereitgestellten Informationen auf dieser Website erwachsen, wird – soweit rechtlich zulässig – ausgeschlossen.
              </p>

              <h3 className="h5 mb-3 mt-4">2. Copyright</h3>
              <p>
                Der Inhalt dieser Website ist urheberrechtlich geschützt. Die Informationen sind nur für die persönliche Verwendung bestimmt. Jede weitergehende Nutzung, insbesondere die Speicherung in Datenbanken, Vervielfältigung und jede Form von gewerblicher Nutzung sowie die Weitergabe an Dritte – auch in Teilen oder in überarbeiteter Form, insbesondere von Fotos, Abbildungen und Texten – ohne Zustimmung des Betreibers der Website ist untersagt.
              </p>

              <h3 className="h5 mb-3 mt-4">3. Haftung für Links</h3>
              <p>
                Diese Website kann Links zu externen Websites enthalten, jedoch hat der Betreiber der Website keinen Einfluss auf diese Zielseiten. Deshalb wird für diese fremden Inhalte auch keine Gewähr übernommen, dafür ist stets der jeweilige Anbieter der Seiten verantwortlich.
              </p>
            </div>
          </motion.div>
        </Container>
      </div>
    </PageTransition>
  );
};

export default Impressum; 